import React from 'react'

interface Props {
  size?: number
}

export const PersonIcon = ({size = 20}: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden="true"
  >
    <path d="M2.132 13.694C1.036 6.917 6.917 1.036 13.694 2.132c4.087.698 7.476 4.087 8.174 8.174 1.096 6.777-4.785 12.658-11.562 11.562-4.187-.698-7.476-4.087-8.174-8.174m9.768 5.283h.3c2.392-.1 4.385-1.296 5.68-3.09-.996-.498-1.993-.897-3.09-1.296l-.497-.199c-.2-.1-.4-.399-.4-.598-.099-.498-.099-.997.2-1.395.598-.698 1.296-1.595 1.296-3.888v-.398c0-1.695-1.495-3.09-3.29-3.09h-.498c-1.794.2-2.99 1.694-2.99 3.488 0 2.293.598 3.19 1.296 3.888.299.398.299.897.2 1.395 0 .3-.2.498-.4.598l-.498.2q-.328.13-.669.263c-.804.315-1.643.643-2.42 1.032 1.195 1.894 3.388 3.09 5.78 3.09"></path>
  </svg>
)
